import { useNavigate } from "react-router-dom";

import Loading from "components/Loading";
import { useMount } from "hooks/effects";

// Firebase Authenticationのメールのリンクの処理を行うためのコンテナ
// パスワードリセット、メールアドレスの確認で異なるURLを指定できない
// そのため、一旦このコンテナで受けて、URLパラメータのmodeを見てリダイレクトさせる
const AuthActionContainer = () => {
  const navigate = useNavigate();
  useMount(() => {
    const mode = new URLSearchParams(window.location.search).get("mode");

    if (mode == "resetPassword") {
      navigate(`/password-reset/change${window.location.search}`);
    } else if (mode == "verifyEmail") {
      navigate(`/mfa/email-verify-complete${window.location.search}`);
    } else if (mode == "revertSecondFactorAddition") {
      navigate(`/mfa/revert${window.location.search}`);
    } else {
      navigate("/");
    }
  });

  return <Loading />;
};

export default AuthActionContainer;
